import React, {useContext} from 'react';
import DiscountsContextProvider from './DiscountsContextProvider';
import DiscountsContext from './DiscountsContext';
import LoadingPage from "../../views/LoadingPage";

/**
 * Inserts UserContextProvider in the react tree
 * before adding the given component.
 *
 * @param {Object} Component The component that needs the context provider.
 * @returns {Object} The component to render wrapped with the provider.
 */
const withDiscountsContextProvider = (Component) => (props) => (
    <DiscountsContextProvider>
        <Component {...props} />
    </DiscountsContextProvider>
);

/**
 * Renders the given component when the user context is ready.
 *
 * @param {Object} Component The component to render.
 * @param {Object} Component The rendered component.
 * @returns {Object} The component to render or the LoadingPage component.
 */
const withDiscountsContextReady = (Component) => (props) => {

    const {isReady} = useContext(DiscountsContext);
    return isReady ? <Component {...props} /> :
        <LoadingPage/>
};

export {
    withDiscountsContextReady,
    withDiscountsContextProvider,
};